import { groupBy } from 'lodash';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { dispatch, select } from '@swf/core/store';
import { BonusGameTypeVariant, BonusStatus } from '@swf/core/types/CasinoBonus';
import { sortSOTDData } from '@swf/core/utils/casino';

const groupFunc = ({ variantType }: { variantType: string }) =>
  variantType === BonusGameTypeVariant.BonusRound ? 'bonusRoundTickets' : 'standardTickets';

const useSpinOfTheDayGameData = () => {
  const spinOfTheDay = useSelector(select.spinOfTheDay.getData);

  useEffect(() => {
    if (!spinOfTheDay) {
      dispatch.spinOfTheDay.fetch();
    }
  }, [spinOfTheDay]);

  const { standardTickets = [], bonusRoundTickets = [] } = useMemo(() => {
    const sotdBonuses = spinOfTheDay ? Object.values(spinOfTheDay).map((value) => value) : [];

    return groupBy(
      sotdBonuses
        .filter(
          (bonus) =>
            bonus.status === BonusStatus.Available ||
            (bonus.status === BonusStatus.Playing && bonus.numberOfSpins > 0)
        )
        .toSorted(sortSOTDData),
      groupFunc
    );
  }, [spinOfTheDay]);

  const standardBonusGame = standardTickets[0] || {};
  const bonusRoundsBonusGame = bonusRoundTickets[0] || {};

  return { standardTickets, standardBonusGame, bonusRoundTickets, bonusRoundsBonusGame };
};

export default useSpinOfTheDayGameData;
